/**
 * Números para leitura humana, em português.
 *
 * Antes disto a moeda era `toFixed` com prefixo escrito à mão — o que produzia
 * "R$ 41.28" com ponto decimal, em reais. `Intl` resolve separador, símbolo e
 * agrupamento de uma vez.
 */

const DOLAR = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "USD" });
const REAL = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
const INTEIRO = new Intl.NumberFormat("pt-BR");

/**
 * Custo em dólares.
 *
 * Valores de IA são pequenos: uma chamada custa centavos de dólar, e duas casas
 * transformariam US$ 0,004 em US$ 0,00. Abaixo de dez centavos mostra quatro
 * casas.
 */
export function dolar(valor: number | string | null | undefined): string {
  const n = Number(valor ?? 0);
  if (!Number.isFinite(n)) return "—";
  return n > 0 && n < 0.1
    ? DOLAR.format(n).replace(/[\d.,]+$/, n.toFixed(4).replace(".", ","))
    : DOLAR.format(n);
}

export function real(valor: number | string | null | undefined): string {
  const n = Number(valor ?? 0);
  return Number.isFinite(n) ? REAL.format(n) : "—";
}

export function inteiro(valor: number | null | undefined): string {
  return INTEIRO.format(valor ?? 0);
}

/** "18/08" — para eixos de gráfico, onde o ano é ruído. */
export function diaCurto(iso: string): string {
  const [, mes, dia] = iso.split("-");
  return `${dia}/${mes}`;
}

/**
 * "18/08 14:22" — dia e hora, sem ano e sem segundos.
 *
 * As chamadas de um evento acontecem todas no mesmo dia; o que distingue uma da
 * outra é a hora. O ano só apareceria repetido em cada linha.
 */
export function dataHora(valor: string | Date | null | undefined): string {
  if (!valor) return "—";
  const d = valor instanceof Date ? valor : new Date(valor);
  if (Number.isNaN(d.getTime())) return "—";

  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)} ${p(d.getHours())}:${p(d.getMinutes())}`;
}
